/* =============================================================================
 * [OS-LEGADO-CONGELADO] ARQUIVO TEMPORARIO - APAGAR APOS VALIDACAO
 * =============================================================================
 * Copia CONGELADA do modulo antigo de "OS para coleta" (versao que estava em
 * producao antes da entrada do modulo novo).
 *
 * Origem desta copia: src/Views/app/precisao/laborder/components/visualizarMapaTabela/index.tsx
 * Papel: pagina do modulo legado
 *
 * POR QUE ISSO EXISTE
 *   O modulo novo de OS substituiu o antigo. Esta copia fica disponivel por
 *   ~1 SEMANA como plano de contingencia: se o modulo novo apresentar
 *   problema, o time volta a usar esta versao sem interromper o trabalho.
 *
 * NAO EDITE ESTE ARQUIVO
 *   Ele e um retrato fiel do comportamento antigo. Qualquer correcao deve ser
 *   feita no modulo NOVO. Editar aqui destroi o valor da copia.
 *
 * COMO APAGAR (quando o modulo novo for validado)
 *   1. Remover a pasta inteira: src/Views/app/precisao/OSAntigaLegado/
 *   2. Remover a rota/menu marcado com [OS-LEGADO-CONGELADO] em
 *      src/Configs/Navegacao.ts
 *   3. Conferir que nao sobrou nenhuma referencia:
 *        grep -rn "OSAntigaLegado\|OS-LEGADO-CONGELADO" src/
 *   Nada fora desta pasta depende dela, entao a remocao e segura.
 * ========================================================================== */

import { faMapMarker, faXmark } from '@fortawesome/free-solid-svg-icons'
import { GoogleMap, Marker, Polyline } from '@react-google-maps/api'
import React, { useEffect, useState } from 'react'
import { calculoAreaCoord, getBoundsNoArray } from '../../../_interno/services/Afins'
import { getPedLaboratorio } from '../../../_interno/services/Laboratorio'
import { destroyAlert, loadingAlert } from '../../../_interno/utils/alert'
import { Button, Modal } from 'antd'
import ButtonCustom from '../../../_interno/Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box } from '../../../_interno/Components/CustomUi/box'

interface PropsVisuMaps {
  open: boolean
  update: number
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export const VisualizarMapaTabela: React.FC<PropsVisuMaps> = (props) => {
  const { open, update, setOpen } = props

  const [geoJson, setGeoJson] = useState<any>([])
  const [kmlAnalise, setKmlAnalise] = useState({})
  const [grupoAnalises, setGrupoAnalises] = useState([])
  const [malha, setMalha] = useState<any>([])
  const [map, setMap] = useState<google.maps.Map>()

  const [listLinha, setListLinha] = useState<google.maps.LatLngLiteral[]>([])
  const linha = () => {
    //@ts-ignore
    const polyline: google.maps.LatLngLiteral[] = kmlAnalise.coordenadas?.map((rec) => {
      return {
        lat: Number(rec.latitude),
        lng: Number(rec.longitude),
      }
    })
    setListLinha(polyline)
  }

  async function buscarAnalise() {
    loadingAlert({ msg: 'Carregando...', id: 'loading_outro' })
    const resp = await getPedLaboratorio(update)
    const dados = resp.data.itens[0]
    setKmlAnalise(dados.talhao_kml)
    setGrupoAnalises(dados.analises)
    setMalha(dados.malha_de_pontos)
    destroyAlert('loading_outro')
  }

  useEffect(() => {
    if (malha?.features) {
      linha()
      const dadosGeo = malha

      dadosGeo.features.forEach((data) => {
        data.color = '#ffffff'
      })

      dadosGeo.features.forEach((data) => {})
      setGeoJson(malha)
    }
  }, [malha])

  useEffect(() => {
    if (map) {
      const bounds = getBoundsNoArray(listLinha)
      if (!map.getBounds()?.intersects(bounds)) {
        map.fitBounds(bounds)
      }
    }
  }, [listLinha])

  useEffect(() => {
    if (update > 0) {
      buscarAnalise()
    }
  }, [update])

  return (
    <Modal
      forceRender
      title={
        <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
          <div>
            <ButtonCustom
              onClick={() => setOpen(false)}
              icon={<FontAwesomeIcon icon={faXmark} />}
              danger
              type='tertiary'
            >
              Fechar
            </ButtonCustom>
          </div>
          <div style={{display: 'flex', gap: 5}}>
            <div style={{ marginRight: 10, display: 'flex', alignItems: 'center' }}>
              <span style={{ fontWeight: '600', fontSize: '13px',  margin: 0, padding: 0 }}>
                Área: {calculoAreaCoord([listLinha])} ha
              </span>
            </div>
            <div style={{ marginRight: 10, display: 'flex', alignItems: 'center' }}>
              <span style={{ fontWeight: '600', fontSize: '13px', margin: 0, padding: 0 }}>
                Grid:{' '}
                <span style={{ fontWeight: '500', fontSize: '13px', margin: 0, padding: 0 }}>
                  {(calculoAreaCoord([listLinha]) / geoJson?.features?.length).toFixed(2)} pontos/ha
                </span>
              </span>
            </div>
          </div>
        </div>
      }
      style={{
        minHeight: '91vh',
        minWidth: '70%',
        marginTop: 0,
        top: 0,
      }}
      closeIcon={false}
      open={open}
      onCancel={() => setOpen(false)}
      footer={false}
      destroyOnClose
    >
      {/* @ts-ignore */}

      <GoogleMap
        onLoad={setMap}
        options={{
          mapTypeId: 'satellite',
          mapTypeControl: false,
          streetViewControl: false,
          clickableIcons: true,
        }}
        mapContainerStyle={{
          width: '100%',
          height: '81vh',
          border: '2px solid #d9d9d9',
          borderRadius: '5px',
        }}
      >
        {geoJson?.features?.map((data) => {
          return (
            <>
              {/* @ts-ignore */}
              <Marker
                icon={{
                  path: faMapMarker.icon[4] as string,
                  anchor: new window.google.maps.Point(190, 550),
                  fillColor: data.color,
                  fillOpacity: 1,
                  strokeWeight: 1,
                  strokeColor: '#ffffff',
                  scale: 0.055,
                  labelOrigin: new window.google.maps.Point(190, 220),
                }}
                animation={window.google.maps.Animation.DROP}
                options={{
                  clickable: false,
                  draggable: false,
                }}
                label={{
                  className: 'color-marker-label',
                  text: parseInt(data.properties.NOME, 10).toString(),
                  fontSize: '11px',
                  fontWeight: 'bold',
                }}
                key={data.properties.INDICE}
                position={{
                  lat: parseFloat(data.geometry.coordinates[1]),
                  lng: parseFloat(data.geometry.coordinates[0]),
                }}
              />
            </>
          )
        })}
        <Polyline
          options={{
            path: listLinha,
            geodesic: true,
            strokeColor: '#00f75b',
            strokeOpacity: 1.0,
            strokeWeight: 4,
            zIndex: 0,
          }}
        />
      </GoogleMap>
    </Modal>
  )
}